export default {
    name: 'calendar_location_room_schedule',
    definition: {
        color_location: '',
        room_id: '',
        end: '',
        interval: '',
        location_id: '',
        start: '',
    },
    options: {
        collectionPath: 'calendar/location_room_schedules',
    },
};
